import Vue from 'vue'
import App from './App.vue'
import router from './router'
import LoadScript from 'vue-plugin-load-script';
import mixins from './mixins'

Vue.config.productionTip = false

Vue.use(LoadScript);
Vue.mixin(mixins);
new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
